class InstaStories {
  constructor(container) {
    if (!container) {
      console.error('Container .insta-stories não encontrado!');
      return;
    }

    this.container = container;
    this.sectionId = container.dataset.section;
    this.lastIndex = parseInt(container.dataset.lastIndex) || 0;
    this.modal = container.querySelector('.insta-stories__modal');
    this.slider = container.querySelector('.insta-stories__slider');
    this.stories = Array.from(container.querySelectorAll('.insta-story'));
    this.openButtons = Array.from(container.querySelectorAll('.insta-story-open-btn'));
    this.closeButtons = container.querySelectorAll('.insta-stories__close-button');

    // Estado do player
    this.currentStoryIndex = 0;
    this.currentMediaIndex = 0;
    this.isPlaying = false;
    this.isChangingMedia = false;
    this.animationFrame = null;
    this.lastInteractionTime = 0;
    this.isMuted = true; // Começa mutado por padrão (como Instagram)

    this.reopenCooldown = false;


    this.init();
  }

  init() {
    // Eventos básicos
    this.openButtons.forEach(btn => {
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    if (this.reopenCooldown) return; // Impede reabrir logo após fechar
    this.openStory(parseInt(btn.dataset.index));
  });
});


    // Eventos para os botões de fechar
    this.closeButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.closeStory();
      });
    });

    // Navegação por toque/clique
    this.setupNavigation();

    // Delegation de eventos para os controles
    this.modal.addEventListener('click', (e) => {
      // Botão de pause/play
      if (e.target.closest('.insta-story__pause-resume-btn')) {
        e.preventDefault();
        this.togglePlayPause();
      }
      
      // Botão de volume
      if (e.target.closest('.insta-story__volume-btn')) {
        e.preventDefault();
        this.toggleMute();
      }
      
      // Botão de fechar
      if (e.target.closest('.insta-stories__close-button')) {
    e.preventDefault();
    this.closeStory();
    return;
  }
    });
  }

  togglePlayPause() {
    const btn = this.stories[this.currentStoryIndex].querySelector('.insta-story__pause-resume-btn');
    if (this.isPlaying) {
      this.pauseCurrentMedia();
      btn.dataset.paused = 'true';
    } else {
      this.playCurrentMedia();
      btn.dataset.paused = 'false';
    }
  }

  toggleMute() {
    this.isMuted = !this.isMuted;
    const btn = this.stories[this.currentStoryIndex].querySelector('.insta-story__volume-btn');
    btn.dataset.muted = this.isMuted;
    
    const currentStory = this.stories[this.currentStoryIndex];
    const mediaItems = currentStory.querySelectorAll('.insta-story__media');
    const currentMedia = mediaItems[this.currentMediaIndex];
    
    if (currentMedia.dataset.type === 'video') {
      const video = currentMedia.querySelector('video');
      if (video) {
        video.muted = this.isMuted;
      }
    }
  }

  setupNavigation() {
    const handleInteraction = (e) => {
  const now = Date.now();

  if (
    this.modal.dataset.open !== 'true' ||
    this.isChangingMedia ||
    (now - this.lastInteractionTime) < 300
  ) {
    return;
  }

  // 👇 NOVO: se clicaste num botão ou num elemento que não seja fundo, ignora
  const clickedElement = e.target;
  if (
    clickedElement.closest('.insta-story__info__btn') || 
    clickedElement.closest('.insta-stories__close-button')
  ) {
    return;
  }

  this.lastInteractionTime = now;
  this.isChangingMedia = true;

  const x = e.clientX || (e.touches && e.touches[0].clientX);
  if (!x) {
    this.isChangingMedia = false;
    return;
  }

  const screenWidth = window.innerWidth;
  const clickPosition = x / screenWidth;

  if (clickPosition > 0.66) {
    this.nextMedia();
  } else if (clickPosition < 0.33) {
    this.prevMedia();
  } else {
    this.isChangingMedia = false;
  }
};


    // Eventos de toque para navegação
    this.modal.addEventListener('click', handleInteraction);
    this.modal.addEventListener('touchstart', handleInteraction, { passive: true });

    // Eventos para pausar ao pressionar
    this.modal.addEventListener('touchstart', (e) => {
      this.pauseCurrentMedia();
    }, { passive: true });

    this.modal.addEventListener('touchend', (e) => {
      if (this.modal.dataset.open === 'true') {
        this.playCurrentMedia();
      }
    }, { passive: true });

    this.modal.addEventListener('touchcancel', (e) => {
      if (this.modal.dataset.open === 'true') {
        this.playCurrentMedia();
      }
    }, { passive: true });

    // Mouse events (passive for better INP)
    this.modal.addEventListener('mousedown', (e) => {
      this.pauseCurrentMedia();
    }, { passive: true });

    this.modal.addEventListener('mouseup', (e) => {
      if (this.modal.dataset.open === 'true') {
        this.playCurrentMedia();
      }
    }, { passive: true });

    this.modal.addEventListener('mouseleave', (e) => {
      if (this.modal.dataset.open === 'true') {
        this.playCurrentMedia();
      }
    }, { passive: true });
  }

  openStory(index) {
    this.currentStoryIndex = index;
    this.currentMediaIndex = 0;
    this.modal.dataset.open = 'true';
    document.body.style.overflow = 'hidden';

    this.stories.forEach((story, i) => {
      story.style.display = i === index ? 'block' : 'none';
      story.dataset.activeMediaIndex = '0';
    });

    // Reset dos controles
    const pauseBtn = this.stories[this.currentStoryIndex].querySelector('.insta-story__pause-resume-btn');
    const volumeBtn = this.stories[this.currentStoryIndex].querySelector('.insta-story__volume-btn');
    
    if (pauseBtn) {
      pauseBtn.dataset.paused = 'false';
    }
    if (volumeBtn) {
      volumeBtn.dataset.muted = 'true';
      this.isMuted = true;
    }

    this.setupProgressBars();
    this.playCurrentMedia();
  }

  setupProgressBars() {
    const currentStory = this.stories[this.currentStoryIndex];
    const progressContainer = currentStory.querySelector('.insta-story__progress');
    const mediaItems = currentStory.querySelectorAll('.insta-story__media');

    progressContainer.innerHTML = '';

    mediaItems.forEach((_, i) => {
      const progressItem = document.createElement('span');
      progressItem.className = 'insta-story__progress-item';
      progressItem.style.setProperty('--duration', `${mediaItems[i].dataset.duration}s`);

      const progressBar = document.createElement('span');
      progressBar.className = 'insta-story__progress-bar';
      progressBar.style.width = i < this.currentMediaIndex ? '100%' : '0%';
      
      progressItem.appendChild(progressBar);
      progressContainer.appendChild(progressItem);
    });
  }

  playCurrentMedia() {
    if (this.isPlaying) return;
    
    const currentStory = this.stories[this.currentStoryIndex];
    const mediaItems = currentStory.querySelectorAll('.insta-story__media');
    const progressBars = currentStory.querySelectorAll('.insta-story__progress-bar');

    if (this.currentMediaIndex >= mediaItems.length) {
      this.nextStory();
      return;
    }

    mediaItems.forEach((media, i) => {
      media.style.display = i === this.currentMediaIndex ? 'block' : 'none';
    });

    const timePosted = currentStory.querySelector('.insta-story__time-posted');
    if (timePosted) {
      timePosted.textContent = mediaItems[this.currentMediaIndex].dataset.timePosted;
    }

    const currentMedia = mediaItems[this.currentMediaIndex];
    if (currentMedia.dataset.type === 'video') {
      const video = currentMedia.querySelector('video');
      if (video) {
        video.currentTime = 0;
        video.muted = this.isMuted;
        video.play().catch(e => console.error('Erro no vídeo:', e));
      }
    }

    const duration = parseFloat(currentMedia.dataset.duration);
    const progressBar = progressBars[this.currentMediaIndex];
    let startTime = null;

    const animateProgress = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / (duration * 1000), 1);
      progressBar.style.width = `${progress * 100}%`;

      if (progress < 1) {
        this.animationFrame = requestAnimationFrame(animateProgress);
      } else {
        this.nextMedia();
      }
    };

    this.clearTimeouts();
    this.animationFrame = requestAnimationFrame(animateProgress);
    this.isPlaying = true;
    currentStory.dataset.activeMediaIndex = this.currentMediaIndex;
    this.isChangingMedia = false;

    // Atualiza botão de play/pause
    const pauseBtn = currentStory.querySelector('.insta-story__pause-resume-btn');
    if (pauseBtn) {
      pauseBtn.dataset.paused = 'false';
    }
  }

  pauseCurrentMedia() {
    if (!this.isPlaying) return;
    this.isPlaying = false;
    cancelAnimationFrame(this.animationFrame);

    const currentStory = this.stories[this.currentStoryIndex];
    const mediaItems = currentStory.querySelectorAll('.insta-story__media');
    const currentMedia = mediaItems[this.currentMediaIndex];

    if (currentMedia.dataset.type === 'video') {
      const video = currentMedia.querySelector('video');
      if (video) video.pause();
    }

    // Atualiza botão de play/pause
    const pauseBtn = currentStory.querySelector('.insta-story__pause-resume-btn');
    if (pauseBtn) {
      pauseBtn.dataset.paused = 'true';
    }
  }

  nextMedia() {
    const currentStory = this.stories[this.currentStoryIndex];
    const mediaItems = currentStory.querySelectorAll('.insta-story__media');

    if (this.currentMediaIndex < mediaItems.length - 1) {
      this.currentMediaIndex++;
      this.setupProgressBars();
      this.playCurrentMedia();
    } else {
      this.nextStory();
    }
  }

  prevMedia() {
    if (this.currentMediaIndex > 0) {
      this.currentMediaIndex--;
      this.setupProgressBars();
      this.playCurrentMedia();
    } else {
      this.prevStory();
    }
  }

//  nextStory() {
  //if (this.currentStoryIndex < this.lastIndex) {
    //this.currentStoryIndex++;
    //this.currentMediaIndex = 0;
    //this.openStory(this.currentStoryIndex);
  //} else {
    //this.closeStory(); // <-- fecha os stories quando chega ao último
  //}

 // this.isChangingMedia = false;
//}


  nextStory() {
  if (this.currentStoryIndex >= this.lastIndex) {
    this.closeStory();
    return; 
  }

  this.currentStoryIndex++;
  this.currentMediaIndex = 0;
  this.openStory(this.currentStoryIndex);
  this.isChangingMedia = false;
}


  

  prevStory() {
    if (this.currentStoryIndex > 0) {
      this.currentStoryIndex--;
      this.currentMediaIndex = 0;
      this.openStory(this.currentStoryIndex);
    }
    this.isChangingMedia = false;
  }

  clearTimeouts() {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
    }
  }

  closeStory() {
    this.modal.dataset.open = 'false';
    document.body.style.overflow = '';
    this.pauseCurrentMedia();
    this.clearTimeouts();
    this.isChangingMedia = false;

// Ativa cooldown de reabertura
  this.reopenCooldown = true;
  setTimeout(() => {
    this.reopenCooldown = false;
  }, 500); // meio segundo deve chegar
    
  }
}

// Inicialização automática
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.insta-stories').forEach(container => {
    try {
      new InstaStories(container);
    } catch (error) {
      console.error('Erro na inicialização:', error);
    }
  });
});